import React from "react";
import { Box, Typography } from "@mui/material";
import { useRouteError } from "react-router-dom";
import logger from "../../utils/logger";

const ErrorPage = ({ error }) => {
  const routerError = useRouteError();
  const routeError = error || routerError;
  logger.error(
    "route error",
    routeError instanceof Error ? routeError : undefined,
    {
      status: routeError?.status,
      statusText: routeError?.statusText,
      message: routeError?.message || routeError?.data?.message,
    },
  );
  error = routeError;
  return (
    <Box
      display="flex"
      flexDirection={"column"}
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
    >
      <img src="/comedyticketing.png" alt="Comedy Ticketing Logo" />
      <Typography variant="h1">Oh no!</Typography>
      <Typography variant="h2">{error.status}</Typography>
      <Typography>{error.statusText || error.message}</Typography>
      {error.data?.message && <Typography>{error.data.message}</Typography>}
    </Box>
  );
};
export default ErrorPage;
